import { cn } from '@shared/lib/utils';

export const DashboardContainer = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div className={cn('mx-auto w-full max-w-5xl p-6', className)} {...props} />
);
